import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled, { DefaultTheme } from 'styled-components';
import { LucideIcon } from 'lucide-react';

interface NavigationLinkProps extends LinkProps {
  isActive?: boolean;
  icon?: LucideIcon;
  label?: string;
  isMobile?: boolean;
}

const StyledLink = styled(Link)<{ $isActive?: boolean; $isMobile?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }: { theme: DefaultTheme }) => theme.spacing[3]};
  color: ${({ theme, $isActive }: { theme: DefaultTheme; $isActive?: boolean }) => $isActive ? theme.colors.primary : theme.colors.textSecondary};
  text-decoration: none;
  font-size: ${({ theme }: { theme: DefaultTheme }) => theme.typography.base};
  transition: ${({ theme }: { theme: DefaultTheme }) => theme.transition.fast};
  padding: ${({ theme }: { theme: DefaultTheme }) => theme.spacing[2]} ${({ theme }: { theme: DefaultTheme }) => theme.spacing[3]};
  border-radius: ${({ theme }: { theme: DefaultTheme }) => theme.borderRadius.md};
  position: relative;

  &:hover {
    background: ${({ theme }: { theme: DefaultTheme }) => theme.colors.background};
  }

  &[aria-current="page"] {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.colors.white};
    background: ${({ theme }: { theme: DefaultTheme }) => theme.colors.primaryLight};
  }

  ${({ $isMobile, theme }: { $isMobile?: boolean; theme: DefaultTheme }) => $isMobile && `
    flex-direction: column;
    gap: ${theme.spacing[1]};
    padding: ${theme.spacing[2]};
    font-size: ${theme.typography.sm};
  `}
`;

export const NavigationLink: React.FC<NavigationLinkProps> = ({ 
  isActive, 
  icon: Icon, 
  label, 
  isMobile,
  children,
  ...props 
}) => {
  return (
    <StyledLink
      {...props}
      aria-current={isActive ? "page" : undefined}
      $isMobile={isMobile}
      $isActive={isActive}
    >
      {Icon && <Icon size={isMobile ? 20 : 24} />}
      {label || children}
    </StyledLink>
  );
}; 